import { useEffect, useState } from 'react';
import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import { SETUP_VIDEO_URL } from '../../lib/google-setup-guide';

export function IndexerSetupVideoPreload({
  src = SETUP_VIDEO_URL,
  className = 'mb-3',
  maxHeight = 420,
}: {
  src?: string;
  className?: string;
  maxHeight?: number;
}) {
  const { config } = useAppContext() as unknown as {
    config: { isDark: boolean };
  };
  const [isVideoReady, setIsVideoReady] = useState(false);

  useEffect(() => {
    setIsVideoReady(false);
  }, [src]);

  return (
    <div
      className={`border rounded-3 overflow-hidden bg-body-tertiary ${className}`.trim()}
    >
      {!isVideoReady && (
        <div
          className="w-100"
          style={{
            maxHeight,
            aspectRatio: '16 / 9',
            background: changeBgColor(config.isDark ? 'dark' : 'light'),
            backgroundSize: '200% 100%',
            backgroundPosition: '100% 0',
            animation: 'run 2s infinite',
          }}
          aria-hidden
        />
      )}
      <video
        key={src}
        className={`w-100 d-block${isVideoReady ? '' : ' d-none'}`}
        style={{ maxHeight }}
        src={src}
        controls
        playsInline
        preload="auto"
        onLoadedData={() => setIsVideoReady(true)}
        onError={() => setIsVideoReady(true)}
      >
        مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
      </video>
    </div>
  );
}
